import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider, InMemoryCache, ApolloClient } from "@apollo/client";

import './index.css';
import App from './App';

import { BrowserRouter as Router } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root")!);

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_TRACE_URL,
    cache: new InMemoryCache(),
});

// Some WebViews (notably the one embedding this app on mobile) resolve `vh`
// units against a shorter height than the real viewport. window.innerHeight
// is accurate everywhere this has been checked, so mirror it into a custom
// property and use that in place of raw vh in layout-critical spots instead
// of chasing the vh bug itself.
const setAppVh = () => {
    document.documentElement.style.setProperty("--app-vh", `${window.innerHeight * 0.01}px`);
};
setAppVh();
window.addEventListener("resize", setAppVh);

root.render(
    <React.StrictMode>
        <Router>
            <ApolloProvider client={client}>
                <App />
            </ApolloProvider>
        </Router>
    </React.StrictMode>
);
